import React from 'react'
import {Row, Block} from 'jsxstyle'

interface CustomToogleProps {
  isChecked: boolean
  onChange: (isChecked: boolean) => void
}

const CustomToogle: React.FC<CustomToogleProps> = ({isChecked, onChange}) => {
  const handleClick = () => onChange(!isChecked)

  return (
    <Row
      width="30px"
      height="16px"
      backgroundColor={isChecked ? '#7A42C2' : '#FFFFFF'}
      border="1px solid"
      borderColor={isChecked ? '#7A42C2' : '#DADCE0'}
      borderRadius="50px"
      cursor="pointer"
      alignItems="center"
      transition="background-color 0.2s ease"
      props={{
        onClick: handleClick,
      }}
    >
      <Block
        width="9px"
        height="9px"
        borderRadius="50px"
        backgroundColor={isChecked ? '#FFFFFF' : '#7A42C2'}
        transform={isChecked ? 'translateX(17px)' : 'translateX(4px)'}
        transition="transform 0.2s ease"
      />
    </Row>
  )
}

export default CustomToogle
